import { render, staticRenderFns } from "./CreditNotesTable.vue?vue&type=template&id=9617369e"
import script from "./CreditNotesTable.vue?vue&type=script&lang=js"
export * from "./CreditNotesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports